import React, { useContext, useEffect, useState } from 'react';
// import _ from 'lodash';
// import { useFormikContext } from 'formik';
import { SaisieContext } from './../../formConteneur';
import { OptionsBouton } from '../../../types/main';
import { EtapesSaisieContext } from '../../../App';

export const BoutonEtapeSuivante: React.FC = (props) => {
  const { nbEtapesSaisie, indexRubriqueSaisie } = useContext(EtapesSaisieContext);
  const {
    modeAffichage,
    setArrowRightPressed,
    boutonSuivant,
  } = useContext(SaisieContext);

  const handleClick = (/* e: React.MouseEvent */): void => {
    // e.preventDefault();
    // console.log('clic sur bouton Etape suivante');
    setArrowRightPressed(true);
  }

  // useEffect(() => {
  //   const handleArrowRight = (event: KeyboardEvent): void => {
  //     // console.log('modeAffichage= ', modeAffichage);

  //     if (event.key === 'ArrowRight') {
  //       event.preventDefault();
  //       if (options === 'oui') setArrowRightPressed(true);
  //     }
  //   }
  //   if (modeAffichage) {
  //     window.addEventListener('keydown', handleArrowRight);
  //   } else {
  //     window.removeEventListener('keydown', handleArrowRight);
  //   }
  //   return (): void => {
  //     window.removeEventListener('keydown', handleArrowRight);
  //   };
  // }, [modeAffichage]);
  useEffect(() => {
    const handleArrowRight = (event: KeyboardEvent): void => {
      // console.log('modeAffichage= ', modeAffichage);

      if (event.key === 'Enter') {
        event.preventDefault();
        // console.log(options);
        setArrowRightPressed(true);
        // if (options === 'oui') setArrowRightPressed(true);
      }
    }
    // if (modeAffichage) {
    if (boutonSuivant === 'oui') {
      window.addEventListener('keydown', handleArrowRight);
    }
    // } else {
    //   window.removeEventListener('keydown', handleArrowRight);
    // }
    return (): void => {
      if (boutonSuivant === 'oui') {
        window.removeEventListener('keydown', handleArrowRight);
      }
    };
  }, [boutonSuivant]);

  const className = ['suivant'];

  if (indexRubriqueSaisie === nbEtapesSaisie - 2) {
    className.push('vert');
  }
  const ret = <button
    id="bouton_etape_suivante"
    onClick={handleClick}
    className={className.join(' ')}
    title="Raccourci clavier : Flèche droite"
    tabIndex={3}
    type="button"
    disabled={boutonSuivant === 'disabled'}
  >
    {/* {indexRubriqueSaisie === nbEtapesSaisie - 2 ? 'J\'ai le bac ?' : 'Etape suivante'} */}
    </button>;

  return boutonSuivant === 'oui' || boutonSuivant === 'disabled' ? ret : null;
}